import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDay,
  faPlus,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "react-bootstrap";
import TablePayrollTemplates from "../../components/table/TablePayrollTemplates";

import { tr } from "../../i18n";
const TabPayrollTemplates = () => {
  return (
    <div>
      <Row>
        <Col lg={12} className="mb-4 mt-3">
          <Row>
            <Col lg={12}>
              <div className="d-flex gap-3 justify-content-end">
                <Link
                  to="/payroll/form"
                  className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm fw-small"
                >
                  <FontAwesomeIcon icon={faPlus} />
                  {tr("payroll:new_template")}
                </Link>
              </div>
            </Col>
          </Row>
        </Col>
        <Col lg={12}>
          <TablePayrollTemplates />
        </Col>
      </Row>
    </div>
  );
};

export default TabPayrollTemplates;
